import { render, staticRenderFns } from "./BriefPublicViewV2.vue?vue&type=template&id=54d82287&scoped=true"
import script from "./BriefPublicViewV2.vue?vue&type=script&lang=js"
export * from "./BriefPublicViewV2.vue?vue&type=script&lang=js"
import style0 from "./BriefPublicViewV2.vue?vue&type=style&index=0&id=54d82287&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d82287",
  null
  
)

export default component.exports